export const h = {
	meta: {
		home: {
			title: "wire China 2026 第12届 | 上海线缆线材全产业链盛会",
			keywords: "中国国际线缆及线材展览会,wire China,上海线缆展,电线电缆展览会,线束展,连接器展,线缆设备展,线缆材料展,2026线缆展,上海新国际博览中心,观众预登记,线缆高峰论坛",
			description: "中国国际线缆及线材展览会（wire China）第12届，2026年9月21-24日亮相上海新国际博览中心。全球领先线缆·线材·线束·连接器全产业链盛会，汇聚全球展商与专业买家，同期举办高峰论坛与技术峰会。即刻预订展位或预登记免费观众证！",
			ogTitle: "中国国际线缆及线材展览会 wire China 2026 | 第12届",
			ogDescription: "全球领先线缆全产业链国际展会 · 2026.9.21-24 上海新国际博览中心",
			ogType: "event",
			ogUrl: "https://www.wirechina.net/",
			ogSiteName: "wire China 2026"
		},
		about: {
			title: "关于wire China | 中国国际线缆及线材展览会介绍",
			keywords: "关于wire China，wire China展会介绍，第十二届线缆展，亚洲线缆展会，国际线缆展，杜塞尔多夫展览，上海电缆研究所，线缆展历史，wire China主办方",
			description: "关于wire China：中国国际线缆及线材展览会是亚洲乃至世界范围内最具影响力的线缆线材行业盛会之一，由上海电缆研究所有限公司与杜塞尔多夫展览(上海)有限公司共同主办，致力于向业界呈现最新的产品、技术及解决方案。"
		},
		media: {
			title: "合作媒体 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China合作媒体，线缆行业媒体伙伴，电缆行业媒体，线缆展会报道媒体，电线电缆媒体，线缆行业新闻合作，wire China媒体合作",
			description: "wire China 2026 合作媒体专区 — 汇集与 wire China 中国国际线缆及线材展览会建立官方合作的行业媒体及大众媒体机构，搭建行业资讯传播与企业品牌曝光的桥梁。"
		},
		dynamic: {
			title: "展会动态 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China展会动态，线缆行业资讯，电线电缆行业新闻，线缆展会新闻，参展商动态，展会新闻报道，行业动态分析，cable exhibition news",
			description: "wire China 2026 展会动态页面，集中发布第12届中国国际线缆及线材展览会的官方新闻、展商动态、行业资讯及技术趋势分析，是了解本届展会进展的第一入口。"
		},
		transport: {
			title: "交通及住宿 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "上海新国际博览中心交通，龙阳路地铁站，上海浦东机场，虹桥火车站，线缆展住宿推荐，wire China交通指南，展会酒店，浦东住宿",
			description: "wire China 2026 交通及住宿指南 — 提供上海新国际博览中心（浦东龙阳路2345号）的地铁、公交、自驾路线，以及展会期间推荐的酒店住宿信息，方便参展商与观众顺利出行。"
		},
		zsLogin: {
			title: "展商登录 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China展商登录，参展商登录入口，展商账号登录，展商密码登录，展位管理登录，展商后台登录，线缆展展商入口",
			description: "wire China 2026 展商登录入口 — 已注册的展商可凭账号、密码或验证码登录展商中心，管理展位资料、宣传物料、参展证件及参展流程。"
		},
		zsCenter: {
			title: "展商中心 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China展商中心，展商后台，展位管理，参展进度，展商服务，展商物料管理，展商证件申请，展位确认",
			description: "wire China 2026 展商中心 — 为参展商提供展位进度查看、宣传物料提报、展商证件申请、参展手册下载、邀请客户登记等全方位展商服务的统一入口。"
		},
		zwApply: {
			title: "展位申请 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China展位申请，2026线缆展展位预订，线缆展招展，展位报价，参展申请，wire China招展热线，电缆展展位预订",
			description: "wire China 2026 展位申请入口 — 第12届中国国际线缆及线材展览会的展位招展页面，支持参展商在线提交展位申请、查询展位图、了解展位报价及招展进度。"
		},
		czProcess: {
			title: "参展流程 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China参展流程，线缆展参展步骤，展位申请流程，参展商参展指南，招展流程，参展手册，wire China参展步骤",
			description: "wire China 2026 参展流程详解 — 从展位申请、合同签订、资料提交、人员注册到现场布展、撤展，完整呈现第12届中国国际线缆及线材展览会的参展全流程。"
		},
		zsPropagateApply: {
			title: "展商宣传申请 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China展商宣传，展会宣传位申请，展商品牌推广，展商广告位，现场物料投放，展商宣传服务，wire China增值服务",
			description: "wire China 2026 展商宣传申请入口 — 为参展商提供展期广告位、会议赞助、现场物料投放、品牌联合推广等增值宣传服务的在线申请通道。"
		},
		vistorRegister: {
			title: "观众注册 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China观众注册，2026线缆展观众预登记，免费参观证，线缆展观众报名，电线电缆观众预登记，参观证申请",
			description: "wire China 2026 观众注册 / 预登记入口 — 提前完成在线预登记，可获得免费参观证，免去现场排队登记流程，享受快速入场、展会资料免费领取等观众专属服务。"
		},
		vistorRegisterCgt: {
			title: "参观团注册 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China参观团，团体观众注册，参观团申请，组团观展，VIP观众礼遇，团体参观，cable exhibition group visit",
			description: "wire China 2026 参观团注册入口 — 5人及以上即可成团登记参观，享受 VIP 观众礼遇：免费会刊、专属通道、团组合影、大巴临时下客证等团队专属服务。"
		},
		vistorCgtCenter: {
			title: "参观团中心 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China参观团中心，团队管理，团员信息，团组资料下载，参观团权益，团体观众后台，参观团状态查询",
			description: "wire China 2026 参观团中心 — 团组负责人可登录管理本团成员信息、查看团组审核进度、下载团体观众专属资料，并享受参观团 VIP 权益。"
		},
		vistorRegisterGz: {
			title: "观众注册（广州） | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China广州观众注册，广州线缆展观众预登记，广州电线电缆展参观证，粤港澳大湾区线缆展，南方线缆行业观众报名",
			description: "wire China 2026 广州观众注册 — 方便粤港澳大湾区及华南地区线缆行业观众就近完成预登记，凭预登记凭证在上海新国际博览中心现场或华南授权换证点领取参观证。"
		},
		meetIndustryConference: {
			title: "行业大会 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China行业大会，中国电线电缆行业大会，电缆行业协会大会，中国电器工业协会电线电缆分会，线缆行业高峰论坛",
			description: "wire China 2026 行业大会 — 第12届中国国际线缆及线材展览会同期举办的中国电线电缆行业大会系列活动，由中国电器工业协会电线电缆分会与上海电缆研究所有限公司共同举办。"
		},
		meetTechnicalExchange: {
			title: "技术交流会 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China技术交流会，线缆技术论坛，电缆技术研讨，高压电缆绝缘，绿色低碳线缆，新能源线缆技术，5G通信海缆，线缆技术创新",
			description: "wire China 2026 技术交流会 — 紧扣高压电缆、绿色低碳、智能装备、新能源线缆、5G 通信海缆等当前热点趋势，邀请线缆行业知名企业与资深专家同台开讲，搭建新产品、新技术的交流平台。"
		},
		meetOverseasExhibition: {
			title: "海外展览 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "海外线缆展，国际电缆展，菲律宾线缆展，德国线缆展，越南线缆展，印尼线缆展，wire Düsseldorf，线缆企业出海",
			description: "wire China 2026 海外展览版块 — 整合主办方旗下重要国际线缆展会信息（包括 wire Düsseldorf 等），助力中国线缆企业了解全球行业展会，开拓海外市场。"
		},
		meetCableCloud: {
			title: "线缆云会 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "线缆云会WICE，上海电缆研究所，特种电缆技术国家重点实验室，中国电器工业协会电线电缆分会，线缆技术线上交流",
			description: "wire China 2026 线缆云会（WICE）— 由特种电缆技术国家重点实验室、中国电器工业协会电线电缆分会与上海电缆研究所有限公司共同主办，提供线缆行业线上技术分享与传播。"
		},
		meetOther: {
			title: "其他会议及活动 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China同期活动，主题论坛，行业沙龙，颁奖典礼，主题参观路线，线缆行业交流活动",
			description: "wire China 2026 同期举办的其他会议及活动 — 包括主题论坛、行业沙龙、颁奖典礼、主题参观路线等多元化活动，为参展商与观众提供更丰富的现场交流机会。"
		},
		productSupplier: {
			title: "特色产品展示（展商） | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China特色产品，展商展品，线缆展展商列表，线缆设备厂家，电线电缆生产设备，电线电缆成品，特种电缆",
			description: "wire China 2026 特色产品展示（展商视角） — 面向采购商的展商展品总览，覆盖线材制造与精加工机械、辅助加工、原辅材料、成品线材及电线电缆、测控与检测工程等全产业链展商与产品。"
		},
		productSupplierDetail: {
			title: "展商产品详情 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "展商展品详情，电线电缆产品详情，线缆展展品页，线缆产品参数，线缆产品应用，展商产品介绍",
			description: "wire China 2026 展商产品详情页 — 展示具体展商所提供产品的型号、参数、应用场景与联系方式，便于采购方深入了解展品并建立联系。"
		},
		productProduceDetail: {
			title: "生产设备详情 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "线缆生产设备详情，拉丝机设备，绞线机设备，成缆机，电缆挤出机，线缆设备技术参数，线缆设备厂商",
			description: "wire China 2026 生产设备详情页 — 详细介绍拉丝机、绞线机、成缆机、挤出机等线缆生产设备的型号、性能、技术参数及对应厂商信息。"
		},
		productAskToBuy: {
			title: "发布求购信息 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "线缆求购信息，采购电线电缆，电线电缆求购，线缆采购需求，线缆产品询价，wire China求购发布",
			description: "wire China 2026 求购信息发布页 — 采购方可在线发布电线电缆、设备及原辅材料的求购需求，由系统与展商库智能匹配并推送至相关展商，提高对接效率。"
		},
		productHome: {
			title: "特色产品展示（采购） | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China特色产品采购，采购专区，电线电缆采购，线缆设备采购，原辅材料采购，线缆采购平台",
			description: "wire China 2026 特色产品采购专区 — 面向采购商的产品总览，按线材制造及精加工机械、辅助加工、原辅材料、特种电线电缆、测控与检测工程等品类聚合展示。"
		},
		ProRecList: {
			title: "推荐产品 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "推荐产品，电线电缆推荐，线缆展热门展品，主推产品，展商精选产品，新品推荐",
			description: "wire China 2026 推荐产品页 — 精选本届展会中受到采购方关注、行业内领先的展商品牌与新产品，集中推荐高质量、特色化线缆产品。"
		},
		ExhibitorRecommendation: {
			title: "推荐展商 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "推荐展商，电线电缆优选展商，wire China优质参展商，知名线缆企业，线缆品牌展商，cable industry leading exhibitors",
			description: "wire China 2026 推荐展商页 — 面向采购方与专业观众，精选行业领先的线缆品牌、知名生产企业和重点参展商，便于快速触达优质合作对象。"
		},
		PopularVideos: {
			title: "热门视频 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China热门视频，展商视频，线缆产品视频，展会精彩回顾，线缆工艺视频，展会直播回放",
			description: "wire China 2026 热门视频专区 — 聚合展商宣传片、产品演示视频、展会精彩回顾与直播回放内容，多角度呈现线缆行业最新技术与现场盛况。"
		},
		productRelease: {
			title: "发布产品 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China发布产品，展商发布新品，线缆新产品发布，wire China新品上架，展商产品上传",
			description: "wire China 2026 发布产品入口 — 展商可在线提交新产品或新技术资料，经审核后展示在展会新产品专区，提升新品曝光与对接效率。"
		},
		vistorCenter: {
			title: "观众中心 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China观众中心，观众后台，参观证管理，观众预约，收藏展商，观众资料下载",
			description: "wire China 2026 观众中心 — 已预登记的观众可登录账号，管理参观证、预约感兴趣的展商、收藏展品，并下载展会相关资料。"
		},
		vistorLogin: {
			title: "观众登录 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China观众登录，参观证账号登录，观众后台登录，观众预登记账号",
			description: "wire China 2026 观众登录入口 — 已预登记的观众可通过手机号、邮箱或参观证编号登录观众中心，查看预约与个性化内容。"
		},
		visaApply: {
			title: "签证申请 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "中国签证申请，线缆展签证邀请函，wire China邀请函，外国观众签证，展会签证，赴华签证，签证申请指南",
			description: "wire China 2026 签证申请服务 — 面向需要赴华参观的国际观众，提供签证邀请函申请、签证办理指南及常见问答，便于跨境观众顺利取得签证。"
		},
		share: {
			title: "分享推广 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China分享推广，展会邀请函分享，线缆展社交分享，参展邀请海报，promotional code 分享",
			description: "wire China 2026 分享推广页 — 展商与观众可生成专属邀请链接、二维码或海报，邀请同行共同参观，统计邀请效果，赢取额外礼遇。"
		},
		resourceCenter: {
			title: "资源中心 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China资源中心，展商手册下载，观众手册下载，展会会刊，展后报告，会刊下载，展会资料",
			description: "wire China 2026 资源中心 — 提供展会邀请函、展馆分布图、参展商手册、观众参观指南、电子会刊及展后报告等官方资料的统一下载入口。"
		},

		czsList: {
			title: "展商名单 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "2026电线电缆展，中国国际线缆及线材展览会，电缆展会信息，电线电缆展会，新国际博览中心，上海电缆研究所有限公司，电线电缆，参展商名录，wire China展商，线缆企业名录",
			description: "wire China 2026 展商名单 — 汇聚第12届中国国际线缆及线材展览会的所有参展企业信息，覆盖线材制造及精加工机械、辅助加工、原辅材料、成品线材及电线电缆、测控技术、检测工程等全产业链展商。"
		},
		vistorMaterials: {
			title: "观众资料下载 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China资料下载，展会会刊，展后报告，展商名单，展会预览，线缆展资料，cable exhibition materials，exhibitor list download，展会邀请函下载，参观指南下载",
			description: "wire China 2026 观众资料下载中心 — 提供展会邀请函、展馆分布图、参展商名单、电子会刊及展后报告等资料的免费下载入口。"
		},
		vistorCgtteamapply: {
			title: "参观团申请 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "参观团注册，参观团申请，团体观众，VIP观众礼遇，组团观展，线缆展团体，cable exhibition group visit，team registration，组团参观，线缆行业组团",
			description: "wire China 2026 参观团申请入口 — 5人及以上即可成团，享受VIP观众礼遇，包括快速领取参观证、免费会刊、团组合影及大巴临时下客证等专属服务。"
		},
		vistorCgtLogin: {
			title: "参观团登录 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "参观团登录，团体观众登录，团组账号，cable exhibition group login，team visitor login，线缆展观众团",
			description: "wire China 2026 参观团登录入口 — 团体观众可通过账号密码登录参观团中心，管理团员信息及团体权益。"
		},
		meetOther: {
			title: "其他会议及活动 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China同期活动，主题论坛，线缆行业沙龙，颁奖典礼，主题参观路线，cable industry events，wire China activities，行业交流活动，主题展览",
			description: "wire China 2026 同期举办的其他会议及活动 — 包括主题论坛、行业沙龙、颁奖典礼、主题参观路线参观等多元化活动，为参展商与观众提供更丰富的现场交流机会。"
		},
		factory: {
			title: "工厂开放日 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China工厂开放日，走进工厂，工厂参观，线缆工厂，电缆制造工厂，工厂深度探访，线缆制造工艺，cable factory tour，wire China Factory Day，工厂沉浸式参观",
			description: "wire China 2026 工厂开放日活动 — 带领行业同仁走进桑浦电缆机械及易藤电气等优质线缆制造企业，实地考察生产一线、技术工艺及综合实力，建立深度信任与合作。"
		},
		dynamicDetail: {
			title: "展会动态详情 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China新闻，线缆行业资讯，展会动态详情，线缆行业新闻，电线电缆行业资讯，cable industry news，行业新闻报道",
			description: "wire China 2026 展会动态详情页 — 分享展会新闻、参展商动态、线缆行业资讯及技术趋势分析，提供线缆行业权威信息。"
		},
		search: {
			title: "搜索 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China搜索，线缆展展商搜索，展品搜索，求购信息搜索，展会动态搜索，cable exhibition search，线缆产品搜索",
			description: "wire China 2026 搜索中心 — 提供展商、展品、求购信息、展会动态、展会资料等多类型内容的统一搜索功能。"
		},
		videoPreview: {
			title: "视频预览 | wire China 2026 第12届中国国际线缆及线材展览会",
			keywords: "wire China视频预告，展会宣传片，线缆展直播预告，wire China视频集锦，cable exhibition video，展会VCR，展商视频",
			description: "wire China 2026 视频预览页面 — 集中呈现展会官方宣传片、展商集锦、直播预告及历年展会精彩回顾视频内容。"
		},
		keno: {
			title: "Keno 智能体 - Wire China 2026",
			keywords: "Keno智能体，wire China智能助手，AI线缆行业助手，展会智能问答，keno AI，cable industry AI assistant",
			description: "Keno 智能体是 wire China 官方推出的线缆行业 AI 智能助手 — 可快速回答关于 wire China 2026 展会、展商、展品及线缆行业相关问题。"
		},
	},
	total: "共",
	record: "条记录",
	tips: "提示",
	require: {
		select: "请选择",
	},
	factoryDay: {
	      mainTitle: "走进材料创新，感受智造实力",
	      subTitle: "走进材料创新，感受智造实力",
	      overview: "首届“工厂开放日”通过走进桑浦电缆机械与易藤电气，让行业同仁切身感受到“眼见为实”对工业合作的重要价值。2026年第二届“工厂开放日”将继续深化这一理念，将交流场景从展台延伸至工厂一线。参与者实地考察，并与企业负责人、技术专家面对面交流，以沉浸式体验建立深度信任，为后续合作提供坚实依据。",
		  overview1: "聚焦供需深度对接，本届工厂开放日将安排深度探访行程。通过此次活动，助力参与者。",
		  overview2: "活动结束后，我们将持续提供后续商贸匹配与对接跟进服务，推动意向转化为实质合作。",
	      visitCompanies: "本次活动将访问：",
	      sampDesc: "桑浦电缆机械(常州)有限公司 - 展示完整的电线电缆生产线的垂直整合制造流程",
	      yitengDesc: "常州易藤电气有限公司 - 以铜合金导体创新，提供尖端解决方案和先进产品",
	      highlightsTitle: "本次活动亮点",
	      highlight1Title: "1. 直击生产一线",
	      highlight1Content: "现场观摩从原料到成品的全流程制造环节，直观了解产能实力、材料品质、工艺水准与品控体系。",
	      highlight2Title: "2. 碰撞技术灵感",
	      highlight2Content: "与资深研发及生产团队深度交流，现场探讨工艺流程及技术难点，在高效对话中激发创新思路。",
	      highlight3Title: "3. 构建合作信任",
	      highlight3Content: "对话企业决策层与核心运营团队，实景见证企业综合实力，高效建立合作互信。",
	      highlight4Title: "4. 拓宽业务渠道",
	      highlight4Content: "精准链接制造链条上的优质资源，寻找稳供应、强制造的长期合作伙伴，拓展业务发展新空间。",
		  routeTitle:"路线安排",
		  route1Title:"1. 智能装备路线",
		  route1Content:"智能装备与数字化产线建设，以技术创新赋能高效生产。",
		  route2Title:"2. 先进材料路线",
		  route2Content:"无卤、低烟、环保阻燃及高性能改性材料的研发与应用。",
		  route3Title:"2. 产业链协同路线",
		  route3Content:"中国电缆产业核心集聚区，全国规模较大、产业链完整、品种齐全的电线电缆制造基地之一。",
		  serviceTitle:"贴心服务",
		  service1Title:"1. 服务保障",
		  service1Content:"提供一站式行程统筹与现场协调服务，涵盖交通、导览、翻译等，并为参与人员购买保险。",
		  service2Title:"2. 专属陪同",
		  service2Content:"配置专属引导人员，全程随行陪同，及时响应需求。",
		  noticeTitle:"注意事项",
		  notice1Title:"1. 报名须知",
		  notice1Content:"名额有限，报名采用审核制，审核通过者，将通过电话、短信或邮件通知确认。",
		  notice2Title:"2. 活动费用",
		  notice2Content:"中国大陆地区参与者800元人民币/人，海外地区参与者100欧元/人，特邀客户尊享免费参与权益。\n（费用包含：活动当日交通、餐费及保险等。）",
		  notice3Title:"3. 报名截止日期",
		  notice3Content:"2026年9月4日（星期五）",
		  notice4Content:"付款信息：上海电缆研究所有限公司\n开户行：交行控江路支行\n账号：31006 6535 0101 4900 7975",
	      factoryPhotos: "工厂照片",
	      factoryIntroTitle: "特约工厂简介",
	      sampTitle: "桑浦电缆机械(常州)有限公司",
	      sampIntro: "SAMP集团于1936年在意大利博洛尼亚成立，经过逐步发展，成为一家能够为客户提供完整电线电缆全流程生产线的公司。其常州工厂作为总公司在亚太地区的核心战略布局，这座工厂不仅是技术与产能的标杆，更凝聚了本土化创新与全球标准的深度融合。",
	      sampProducts: "SAMP生产的机械设备涵盖铜、铝及铝合金的大拉机，中拉机及多头拉丝机生产线和退火装置。生产线配备盘式收线和笼式收线等解决方案，并可以配套双绞束丝机及放线架等装置，以及满足从电信、局域网、同轴电缆到交通、建筑、电子、信号和电力等各类电缆制造需求的绝缘和护套生产线。",
	      sampAdvantage: "与市场上其他解决方案相比，SAMP所有的电线电缆制造机械和生产线均能保证高生产率、出色的灵活性，并在能源和材料消耗方面实现大幅节约。",
	      yitengTitle: "常州易藤电气有限公司",
	      yitengIntro: "公司成立于2014年7月，历经多年发展，现已布局常州、江西两大现代化生产基地，形成规模化、高效化的生产体系。",
		  yitengProducts: "公司业务广泛覆盖汽车、医疗、机器人、工业设备及航空航天等核心领域，聚焦新型铜合金材料导体的研发与生产。其中，铜包钢导体及各类高性能铜合金导体为核心主打产品，凭借优异的导电性能、机械强度与稳定性，在行业内树立了技术标杆。",
		  yitengAdvantage: "凭借过硬的产品品质与技术实力，公司已与莱尼、科斐恺博、博迈立铖、住友、乐庭、卡倍亿等全球知名线束企业建立并保持长期稳定的合作关系，持续为各行业提供可靠的材料解决方案。",
	      registrationTitle: "报名及咨询",
	      contactInfo: "如有任何问题，请联系我们：",
      contactPerson: "联系人",
      contactName: "王诺涵",
      email: "Email",
      tel: "Tel",
	  registerBtn: "立即报名",
	  routeTourTitle: "沉浸式工厂之旅（二选一）",
	  route1Title: "路线1：智能装备路线",
	  route1CompanyLabel: "参观企业：",
	  route1Company: "中天科技数字产业集团",
	  route1HighlightsLabel: "参观亮点：",
	  route1Highlights: "专注智能装备与数字化产线建设，以技术创新赋能高效生产。",
	  route1Desc: '中天科技数字产业集团秉承"软硬一体成系统、无人智能向未来"的发展理念，前瞻布局人工智能、智能机器人、健康医疗、无人机等未来赛道，以技术突破驱动新质生产力孵化与产业化，目标打造区域与行业人工智能+智能制造标杆，携手客户与上下游合作伙伴，持续赋能数字化建设赋能。',
	  route2Title: "路线2：产业链协同路线",
	  route2CompaniesLabel: "参观企业：",
	  route2Companies: "无锡市中鼎电工机械有限公司、远东新材料有限公司",
	  route2HighlightsLabel: "参观亮点：",
	  route2Highlights: "深入中国电缆产业的核心集聚区，考察装备制造与新材料研发标杆企业。",
	  zhongdingTitle: "无锡市中鼎电工机械有限公司",
	  zhongdingDesc: "无锡市中鼎电工机械有限公司是一家集研发、设计、制造电线电缆专用设备的高新技术企业，主要产品有高速挤出机类、绕包机类、绞线机类等线缆设备。公司拥有专门的技术研究部门——\"无锡市中鼎高速线缆设备工程技术研究中心\"，引进了一批高水平专业人才，积极与高校开展产学研合作，重点开展线缆设备领域的自主研发，不断推出一系列具有自主知识产权、自动化程度高的专业设备。",
	  farEastTitle: "远东新材料有限公司",
	  farEastDesc: "远东新材料有限公司是远东智慧能源股份有限公司的全资子公司。公司配备国内外先进的生产设备，其中拥有先进流水线12条，年产销规模达6亿元。公司致力于研发和生产电缆用高分子新材料，主要有聚氯乙烯绝缘料、聚氯乙烯护套料、聚氯乙烯阻燃料；10~35kV过氧化物交联聚乙烯绝缘料；10kV及以下硅烷交联聚乙烯绝缘、架空料；低烟无卤阻燃电缆护套料、低烟无卤阻燃电缆绝缘料等系列产品。"
	    },
	home: {
		h1: "中国国际线缆及线材展览会（wire China 2026）",
		box1: {
			label1: "平",
			content1: "展会面积",
			label2: "人",
			content2: "专业观众",
			label3: "家",
			content3: "知名展商",
			label4: "场",
			content4: "专题交流",
		},
		box2: {
			title: "中国国际线缆及线材展览会（wire China）",
			content:
				"始创于2004年，两年一届，现已成长为全球领先的线缆、线材行业展览会。主办方上海电缆研究所有限公司和杜塞尔多夫展览（上海）有限公司发挥各自优势，汇聚全球优质参展商及买家，推动行业交流与信息共享，以专业的视角呈现行业最新产品、技术及解决方案。",
			btn1: "展会概览",
			btn2: "展馆分布图",
			btn3: "上届概览",
			btn4: "参展商名单",
		},
		box3: {
			title: "展会动态",
		},
		box4: {
			label1: "了解详情",
			label2: "详情",
			label3: "查看更多",
		},
		box5: {
			title: "参展企业展示",
			tab1: "数智赋能创新装备",
			tab2: "辅助加工配套",
			tab3: "绿色低碳解决方案",
			tab4: "品质线缆线材",
			tab5: "精准测控技术",
		},
	},
	about: {
		btn1: "基本信息",
		btn2: "展品范围&观众来源",
		btn3: "上届概览",
		btn4: "联系我们",
		box1: {
			content:
				"中国国际线缆及线材展览会（wire China）始创于2004年，两年一届，现已成长为全球领先的线缆、线材行业展览会。主办方上海电缆研究所有限公司和杜塞尔多夫展览（上海）有限公司发挥各自优势，汇聚全球优质参展商及买家，推动行业交流与信息共享，以专业的视角呈现行业最新产品、技术及解决方案。",
			date: "时间：2026年9月21日-24日",
			addressLabel: "地点：",
			addressValue: "上海新国际博览中心",
			title: "主办单位",
			listTitle1: "上海电缆研究所有限公司",
			listContent1:
				"上海电缆研究所有限公司是中国唯一的集电线电缆研发、工程设计、检测、信息会展服务及行业工作于一体的研究机构。主要从事各种裸电缆、架空线、橡塑绝缘电气装备用电线电缆、高压/超高压电线电缆、通讯电缆、光钎电缆、建筑结构用承力索等产品及附件的研发和试验；研发电线电缆用的各种导体、绝缘和护套材料；研究、设计及生产电线电缆用设备及检测仪器；设计承包相关工厂及工程项目；对电线电缆产品及附件进行检测；受国家和地方委托，对电线电缆产品进行质量认证。此外，还从事国内电线电缆及专用设备标准的技术归口工作以及特殊电线电缆的制造，是国家电工委员会(IEC）中国国际委员会电线电缆4个技术委员会(TC）及2个分技术委员会(SC）的归口单位。",
			listTitle2: "杜塞尔多夫展览（上海）有限公司",
			listContent2:
				"杜塞尔多夫展览（上海）有限公司成立于2009年，是世界知名展览主办者的杜塞尔多夫展览集团公司在中国的子公司，拥有完善成熟的营销和服务网络，致力于将世界一流的专业展览带到中国，并为中国市场及客户提供个性化的优质服务。自成立以来，历经多年来的创新发展，公司在印刷、包装、线材线缆及管材、塑料、医疗器械、零售、安全生产及职业健康、葡萄酒与烈酒、房车等行业成功打造了13个中国乃至亚洲地区的第一展览品牌及会议。目前，公司总部位于上海，在北京设有办公机构，拥有70余位正式员工。",
			web: "查看官网",
		},
		box2: {
			title1: "展品范围",
			listLabelNew1: "测控技术",
			listLabelNew2: "检测工程",
			listLabelNew3: "其他相关领域",
			listLabel1: "线缆线材制造及精加工机械",
			listLabel2: "线缆辅助加工",
			listLabel3: "线缆（光缆）用原辅材料",
			listLabel4: "成品线材及电线电缆",
			listLabel5: "弹簧制造设备及技术",
			listLabel6: "紧固件制造设备及技术",
			listLabel7: "测控技术",
			listLabel8: "检测工程",
			listLabel9: "相关领域",
			title2: "观众来源",
			btn1: "电线电缆",
			btn2: "光纤光缆工业",
			btn3: "线材工业",
			btn4: "汽车工业",
			btn5: "钢铁和有色金属工业",
			btn6: "信息科技及电信产业",
			btn7: "航空航天工业",
			btn8: "电子工业",
			btn9: "电气工业",
			btn10: "建筑工业",
			btn11: "相关协会/科研机构/高校",
			btn12: "相关贸易服务业",
			btn13: "其他相关领域",
			btn14: " ",
			btn15: " ",
		},
		box3: {
			title1: "上届概览",
			content1:
				"作为亚洲一流的线缆线材行业盛会，wire China 2023展会全方位呈现了行业新技术、新产品、新理念，与企业共同把握数字化、智能化、绿色化发展机遇，助力行业开启“加速跑”新征程!\n" +
				'              来自<span class="emphasize"> 96 </span>个国家和地区的<span class="emphasize"> 40,629 </span>名专业观众，较2018年增长了<span class="emphasize"> 30.83%</span>\n' +
				'              来自<span class="emphasize"> 19 </span>个国家和地区的<span class="emphasize"> 900 </span>多家线缆及线材行业品牌展商\n' +
				'              <span class="emphasize">57,500 </span>平方米的专业展览平台\n' +
				'              <span class="emphasize">2 </span>大行业会议、<span class="emphasize">4 </span>场主题论坛、<span class="emphasize">40+ </span>主题交流提领未来破局之道\n' +
				'              <span class="emphasize">5 </span>大主题路线 精准高效沉浸逛展',
			title2: "产业链力量齐聚，释放商贸新势能",
			content2:
				"wire China汇聚了来自个19国家和地区900多家展商，其中包括自德国、法国、意大利、韩国、日本及中国台湾的国家及地区展团。行业领军企业选择wire China作为创新技术推广及新品发布平台。展会吸引了从线缆线材制造及精加工机械，线缆辅助加工，线缆(光缆) 用原辅材料，成品线材及电线电缆，测控技术，检测工程等相关领域，为线缆同仁带来高质量的参展参观体验。",
			title3: "专业观众再创新高，达40,629人",
			content3:
				"海外买家全面回归，本届展会累计有40,629名专业观众到场，观众人数创历史新高，其中包括来自美国、加拿大、澳大利亚、德国、英国、意大利、西班牙、法国、日本、韩国、新加坡、巴西、印度、泰国、越南、阿根廷等96个国家和地区的众多海外买家。wire China 2023聚焦全球线缆人目光，全方位展示了线缆行业的最新发展趋势与创新技术成果，为全面展现行业的澎湃活力与勃勃生机提供了绝佳舞台，收获了专业观众的极大赞许及认可。",
			title4: "观众所属行业",
			content4:
				"电缆行业\n" +
				"              线材工业\n" +
				"              化工行业\n" +
				"              检测设备和技术\n" +
				"              建筑行业\n" +
				"              电子行业\n" +
				"              电机电气行业\n" +
				"              能源行业\n" +
				"              钢铁和有色金属行业\n" +
				"              航空航天工程\n" +
				"              信息科技及电信产业\n" +
				"              石油、天然气工业\n" +
				"              管材行业\n" +
				"              汽车制造业",
			title5: "2大行业会议 40+主题分享 打造行业思想高地",
			content5:
				"wire China围绕“智能制造”、“绿色低碳”、“数字化创新”、“可持续发展”等热门趋势，与政府机构、行业协会、金融机构通力合作，推出为数十场专业论坛/会议，为全球行业同仁创造商机、架设合作桥梁。\n" +
				"\n" +
				"                -2023中国电线电缆行业大会\n" +
				"                -2023绕组线行业技术论坛\n" +
				"                -线缆技术交流会\n" +
				"\n" +
				"                产业经济分论坛、绿色低碳分论坛、智能制造分论坛、数字化创新分论坛轮番登场，行业知名企业、资深专家同台开讲。",
			footerText1: "上届",
			footerText2: "回顾",
			reviewOfLastSession:"上届回顾"
		},
		box4: {
			title1: "参展联络",
			title2: "参观联络/商贸配对",
			title3: "媒体联络",
		},
	},
	dynamic: {
		btn1: "展会最新",
		btn2: "行业聚焦",
		btn3: "电子展讯",
		label: "查看更多",
	},
	tran: {
		btn1: "交通",
		btn2: "住宿",
		title: "为了方便您前往展馆，主办方为您提供了多种方便的交通方式",
		content:
			"作为亚洲一流的线缆线材行业盛会，wireChina 2024展会全方位呈现了行业新技术、新产品、新理念，与企业共同把握数字化、智能化、绿色化发展机遇，助力行业开启“加速跑”新征程!",
		addressLabel: "地址：",
		addressValue: "上海浦东新区龙阳路2345号",
		title2: "如何到达",
		box1: {
			title: "私家车",
			content1:
				"上海新国际博览中心位于龙阳路、罗山路交汇处，从市中心横跨南浦大桥、杨浦大桥可直达。展览期间:上海新国际博览中心7号门停车位充足（花木路一侧）。停车费:每小时8元，单日64元封顶，此费率适用于小轿车或其他轻型车辆",
			content2: "自驾限行通知：",
			content3:
				"上海外牌高架(快速路)限行:周一至周五7:00--20:00（周末及国家法定节假日除外）;上海外牌内环地面道路限行:周一至周五 7:00-9:00、17:00-19:00（周末及国家法定节假日除外）",
		},
		box2: {
			title: "出租车",
			content1: "乘坐出租车直达上海新国际博览中心1号南入口大厅/3号东入口大厅。",
		},
		box3: {
			title: "地铁",
			content1: "上海新国际博览中心，地铁7号线-花木路站可到达SNIEC。",
			content2: "无论您从哪里出发，您都能在以下站点换乘到地铁七号线：",
			content3: "地铁1号线 - 常熟路站地铁",
			content4: "2号线 - 静安寺站地铁",
			content5:
				"3号线 / 地铁4号线 - 镇坪路站地铁4号线 - 东安路站上海地铁交通线路图（可查询）",
		},
		box4: {
			title: "火车",
			content1: "从上海火车站出发",
			content2: "出租车：相距约17公里；约30分钟；车费约60元；",
			content3:
				"地铁：可乘1号线至人民广场站或4号线至世纪大道站下，换乘2号线至龙阳路站下，步行或换乘7号线至展馆2号北入口大厅；约50分钟；车费4元。",
			content4: "从上海南站出发",
			content5: "出租车：相距约20公里；约30分钟，车费约70元；",
			content6:
				"地铁：可乘1号线到人民广场站，换乘2号线至龙阳路站下，步行或换乘7号线至展馆2号北入口大厅；约55分钟；车费5元。",
		},
		box5: {
			title: "飞机",
			content1:
				"上海新国际博览中心坐落于上海浦东国际机场和上海虹桥国际机场之间，东距浦东国际机场约32公里，西距虹桥国际机场约27公里，可乘坐磁浮列车、地铁、机场巴士或出租车可方便抵达展馆。",
			content2: "上海浦东国际机场出发:约35分钟；",
			content3: "上海虹桥机场出发：约35分钟。",
			content4: "出租车：约35分钟（途径机场高速）；",
			content5: "车费约120元；",
			content6:
				"磁浮列车：仅8分钟；单程50元（如出示机票或使用上海交通公交卡，单程40元；",
			content7:
				"往返80元；大巴：机场五线至龙阳路站下，步行或换乘7号线至展馆2号北入口大厅；",
			content8: "约50分钟；车费16元；",
		},
		hotelColunm1: "酒店名称",
		hotelColunm2: "星级",
		hotelColunm3: "地址",
		hotelColunm4: "价格/元(含双早)",
		hotelColunm5: "展会期间班车接送",
		hotelColunm6: "距展馆",
	},
	exApply: {
		title1: "展商展品宣传申请",
		label1:
			"为了给每位参展商提供更好的参展体验，wire China主办方将通过微信公众号、官方网站、视频号等展会官方平台进行参展商亮点展品推广，助力参展商提前抢占采购商视线，为展会现场预热蓄力。",
		label2: "申请要求",
		label3: "参与推广的展商需提供企业图文等素材，",
		label4: "点击",
		label5: "提交宣传素材",
		label6: "主办方确认后进行编辑发布。",
		title2: "媒体联络",
	},
	visaApply: {
		title1: "签证申请",
		label1:
			"所有来华的外籍人士进入中国如需签证。我们建议您在从本国出发前一个月进行签证申请。",
		title2: "邀请函",
		label2:
			"所有签证申请者须持有一份由中国境内EN授权机构发出的邀请函。我们将把您的资料寄往中国境内授权机构，在5天内由授权机构发出正式商务邀请函并通过电邮寄往您的公司。同时，申请者须提供清晰的护照复印件、信用卡正反卡面复印件、酒店确认单和在华行程。",
		title3: "备注",
		label3: "护照有效期须超过预定进入中国境内的日期至少六个月。",
		title4: "点击报名",
	},
	headerLogin1: "展商登录",
	headerLogin2: "观众登录",
	headerSearch: "搜索",
	headerLanguage1: "中文",
	headerLanguage2: "EN",
	headerLanguage3: "日本語",
	headerLanguage4: "한국어",
	headerLanguage5: "ไทย",
	headerLanguage6: "EN",
	footerCompanyName1: "上海电缆研究所有限公司",
	footerCompanyName2: "杜塞尔多夫展览(上海)有限公司",
	footerLabel1: "中国·上海",
	footerLabel2: "wire全景",
	footerLabel3Germany: "德国",
	footerLabel3Eurasia: "印度",
	footerLabel3Mexico: "泰国",
	footerLabel3Thailand: "埃及",
	footerLabel3India: "土耳其",
	footerLabel3MEA: "墨西哥",
	footerLabel4: "关注官微",
	footerLabel5: "及时了解展会动态",
	footerLabel6: "wire China 电子期刊",
	footerLabel7: "即刻订阅 尽享资讯",
	footerLabel8: "杜塞尔多夫展览(上海)有限公司",
	footerLabel8Icp: "沪ICP备13014242号-18",
	footerLabel8Suffix:
		"沪公网安备31011002001870号 版权所有：上海电缆研究所有限公司",
	languageChangeLoading: "正在切换语言...",
	tabName1: "首页",
	tabName2: "展会概览",

	tabName2Item1: "关于wire China",
	tabName2Item2: "展会分布图",
	tabName2Item3: "展会动态",
	tabName2Item4: "合作媒体",
	tabName2Item5: "交通及住宿",
	tabName2Item6: "展会概况",
	tabName2Item7: "展商服务",
	tabName2Item8: "合作媒体",
	tabName3: "展商",
	tabName3Item1: "参展流程",
	tabName3Item2: "参展商名单",
	tabName3Item3: "展位申请",
	tabName3Item4: "展商宣传申请",
	tabName3Item5: "展商登录",
	tabName3Item6: "",
	tabName3Item7: "展商中心",
	tabName4: "观众",
	tabName4Item1: "观众注册",
	tabName4ItemItem1: "观众预登记",
	tabName4Item2: "展会资料",
	tabName4Item3: "特色展品展示",
	tabName4Item4: "观众登录",
	tabName4Item5: "签证申请",
	tabName4Item6: "观众中心",
	tabName5: "会议及活动",
	tabName5Item1: "行业大会",
	tabName5Item2: "技术交流会",
	tabName5Item3: "线缆云会",
	tabName5Item4: "境外展会",
	tabName5Item5: "其他会议及活动",
	tabName6: "特色产品展示",
	tabName6Item1: "展商",
	tabName6Item2: "展品",
	tabName6Item3: "求购信息",
	tabName6Item4: "发布采购需求",
	tabName7: "wireChina工厂开放日",
	tabName7Item1: "活动报名",
	tabResourceCenter: "资源中心",
	registerBox: {
		label1: "观众预登记",
		label2: "立即在线预约登记",
		label3: "参观团登记",
		label4: "10人以上成团，立即在线预约登记",
		label5: "参观联络",
	},
	registerGroup: {
		title: "参观团登记",
		title1: "参观团介绍",
		label1:
			"除了个人参观服务，我们亦提供团队的参观服务。涵盖来自电线电缆工业、钢铁和有色金属工业、汽车工业和航天工业、电气工业、建筑工业、专业贸易等相关行业协会及企业。为免除现场繁复的登记手续及享用参观团礼遇，wireChina 现诚邀各行业协会、企业组团参观。",
		label2: "组团要求",
		label3: "1.人数：10人及以上；",
		label4: "2.报名截止时间：2026年9月04日",
		label5: "3.团组信息提交后，需经主办单位确认后方可成团。",
		label6: "组团参观，尊享VIP观众礼遇！",
		label7: "1.快速领取参观证",
		label8: "2.免费参观指南、电子会刊",
		label9: "3.团组观展礼包",
		label10: "4.团体合影留念",
		label11: "5.大巴车临时下客证",
		label12: "点击下载",
		label13: "wireChina 2026 团体登记表",
		label14:
			"，完整填写表格内容，并按要求发送给主办方联系人员（邮件请发送至wangnuohan@secri.com）",
		label15: "更多信息，请下载：",
	},
	vistorRegister: {
		btn: "下一步",
		title1: "信息验证",
		title1Box: {
			label1: "已是会员？",
			label2: "返回登录",
			label3:
				"感谢您对第12届中国国际线缆及线材展览会（wire China 2026）的关注与支持！",
			label6span1: "若您有5位及以上同行参观者，请点击",
			label6span2: " 此处 ",
			label6span3: "申请团体参观。",
			label6span4:"港澳台及请海外观众",
			label6span5:"注册",
			label7:
				"观众预登记入口将于北京时间2026年9月20日12:00准时关闭，敬请留意。",
			label8: "若您无法正常注册，请拨打021-5116 1389。",
		},
		title2: "填写信息",
		title2Box: {
			title1: "所填信息将用于展会官方网站、微信邀请推广渠道。",
			label1: "姓名",
			holder1: "请输入姓名",
			label2: "称谓",
			holder2: "请选择称谓",
			label3: "身份证号",
			holder3: "请输入身份证号",
			label4: "部门",
			holder4: "请输入部门",
			label5: "职位",
			holder5: "请选择职位",
			label6: "国家及地区",
			holder6: "请选择国家及地区",
			label7: "公司",
			holder7: "请输入公司名称",
			label8: "电话",
			holder8: "请输入电话",
			label9: "网址",
			holder9: "请输入网址",
			label10: "邮编",
			holder10: "请输入邮编",
			label11: "邮箱",
			holder11: "请输入邮箱",
			label12: "详细地址",
			holder12: "请输入详细地址",
			label13: "手机号码",
			holder13: "请输入手机号码",
			holder13Header: "区号",
			label14: "是否到场",
			holder14: "请选择是否到场",
			holder15: "详细地址长度最少为10个字符",
			holder16: "请输入正确的手机号码",
			holder17: "请输入正确的邮箱",
			holder18: "请输入验证码",
			yes: "是",
			no: "否",
		},
		title3: "问卷调查",
		title3Box: {
			holder1: "贵公司产品所属行业",
			holder2: "公司业务性质",
			holder3: "您的参展目的(多选)",
			holder4: "您如何了解到本次展会信息(多选)",
			holder5: "本周展会，您期待见到哪些展品(多选)",
			otherholder15: "15 其他，填写说明",
			otherholder24: "24 其他，填写说明",
			otherholder33: "33 其他，填写说明",
			otherholder45: "45 请输入参展商名称",
		},
		title4: "完成注册",
		title4Box: {
			apply_success: "申请成功",
			label1: "注册成功",
			label2: "尊敬的",
			douhao: "，",
			maohao: "：",
			label3: "感谢您对wireChina的关注与支持！现场携身份证参观。",
			label4: "10人及以上成团参观：",
			label5: "尊享VIP观众优待，组团参观更方便！",
			btn1: "提取电子参观证",
			btn2: "进入观众中心",
			label6: "观众预登记编号",
			label7: "专业观众",
			label8: "5人及以上成团参观：即刻尊享VIP观众礼遇！",
			label9: "组团条件",
			label10: "人数：5人及以上",
			label11:
				"行业：电线电缆、光纤光缆工业、线材工业、钢铁和有色金属工业、汽车工业、信息科技及电信产业、航空航天工业、电子工业、电气工业、建筑工业、相关协会/科研机构/高校、相关贸易服务业、其他。 ",
			label12: "*团员信息经主办单位审核后即可成团",
			label13: "团体观众可尊享：",
			label14: "·	快速领取参观证",
			label15: "·	免费获赠参观指南、电子会刊 ",
			label16: "·	团组观展宣传品",
			label17: "·	观众休息室入场券(提供茶饮等)",
			label18: "",
			label19span1: "立即下载",
			label19span2: "wire China2026团体参观",
			label19span3: "团队报名截至：2026年8月28日。",
			label20: "常见问题",
			label21: "Q1：展会对观众的开放时间",
			label22: "2026年9月21-24日（周一~周四）：09:00-16:30",
			label23: "2026年9月24日（周四）：09:00-14:00",
			label24: "Q2：展会地点",
			label25: "上海新国际博览中心E1-E7馆",
			label26: "地址：上海市浦东新区龙阳路2345号",
			label27: "Q3： 如何换取入场证？",
			label28: "上海新国际博览中心1#入口厅、3#入口厅",
			label29: "现场凭”电子参观证“换取观众证件，凭身份证进场参观。",
			label30: "参观联系",
			label31: "上海电缆研究所有限公司",
			label32: "王诺涵 女士",
			label33: "电话：",
			label34: " 电邮：",
		},
	},
	vistorCenter: {
		title: "上海电缆研究所有限公司",
		footerTitle: "退出登录",
		label1: "尊敬的",
		label2: "感谢您对第12届中国国际线缆及线材展览会（wire China 2026）的关注！",
		label3: "您已成功注册成为本届观众。",
		menuLabel1: "首页",
		menuLabel2: "个人信息",
		menuLabel2Item1: "电子参观证",
		menuLabel2Item2: "参观权益",
		menuLabel2Item3: "修改账户资料",
		menuLabel2Item4: "观众问卷",
		menuLabel3: "参观登记邀请",
		menuLabel3Item1: "为他人预登记",
		menuLabel3Item2: "团体参观服务申请",
		menuLabel3Item3: "邀请好友注册",
		menuLabel4: "供需商贸对接",
		menuLabel4Item1: "我发布的采购需求",
		menuLabel4Item2: "我的咨询",
		menuLabel4Item3: "供应商及产品收藏",
		menuLabel5: "会议活动",
		menuLabel6: "联系我们",
		cardContent1: "电子参观证",
		cardContent2: "参观权益",
		cardContent3: "我发布的需求",
		cardContent4: "供应商及产品收藏",
		cardContent5: "团体参观服务申请",
		cardContent6: "会议活动",
		hoverContent1:
			"您已成功注册成为第12届中国国际线缆及线材展览会的观众，现场凭“预登记确认函+名片”直接换取参观证。现场携身份证参观。",
		hoverContent2:
			"您已成功注册中国国际线缆及线材展览会。我们将为专业买家、观众带来不容错过专享服务及福利。立即点击查看您的权益。",
		hoverContent3:
			"注册成为wireChina 观众，您可发布采购需求，并随时查看发布的采购需求及商贸配对进度。",
		hoverContent4:
			"您可收藏感兴趣的展品及供应商，轻松查阅产品信息及供应商资讯。",
		hoverContent5:
			"除了个人参观服务，我们亦提供团队的参观服务。可免除现场繁复的登记手续，并尊享参观团礼遇。",
		hoverContent6:
			"主办方立足行业前沿，精心组织行业会议、主题论坛，为参展商搭建新产品和新技术发布和交流的平台，助力行业产业链供应链提升发展水平，畅通产业良性循环和智慧发展新路径。",
		modal: {
			title: "温馨提示",
			content: "请先完善观众问卷",
			btn: "去填写",
		},
	},
	vistorLogin: {
		noAccount: "没有账号？",
		registerNow: "立即注册",
		cgtLoginBtn: "观众团登录",
		title: "第12届中国国际",
		title2: "线缆及线材展览会",
		titleSub: "加入中国一流展会",
		loginTitle: "观众登录",
		loginTitle2: "展商登录",
		loginTitle3:"参观团登录",
		loginForm1: "账号",
		loginForm1Holder: "请输入账号",
		loginForm2: "密码",
		loginForm2Holder: "请输入密码",
		loginFormType1: "使用手机号码登录",
		loginFormType2: "使用账号密码登录",
		loginForm3: "手机号",
		loginForm3Holder: "请输入手机号",
		loginForm5Holder: "请输入正确格式的手机号",
		loginForm6Holder:"没有注册，请先注册！",
		loginForm4: "验证码",
		loginForm4Holder: "请输入验证码",
		loginForm5: "获取验证码",
		loginForm6: "秒后重试",
		loginBtn: "登录",
		loginText: "登录成功",
		zsLoginCode: "使用验证码登录",
		zsLoginPsw: "使用密码登录",
	},
	floatingBox: {
		label1: "参展咨询",
		label2: "展位申请",
		label3: "观众预登记",
		label4: "倒计时",
		label5: "天",
		label6: 'Keno 智能体',
	},
	czProcess: {
		title1: "了解展会具体情况",
		content1: "与展会主办联系获取展位信息",
		title2: "填写《参展申请表》",
		content2:
			"决定参展后，填写申请表，盖章后递交给主办方，新参展企业需提供企业营业执照复印件。",
		title3: "主办方发出《展位确认及付款通知》",
		content3: "参展商支付50%展位费",
		title4: "主办方盖章回传《参展申请表》",
		content4: "展位预定成功",
		title5: "获得展商中心权限尊享参展商专属服务",
		content5: "凭用户名和密码，进入展商中心享受参展商服务",
		content5Item1: "●提交公司信息用于会刊及在线宣传",
		content5Item2: "●提交产品两点用于《展会预览/产品亮点手册》",
		content5Item3: "●在线邀请VIP观众",
		content5Item4: "●提交公司楣板信息",
		content5Item5: "●提交参展商胸卡信息",
		content5Item6: "●提交展台搭建表格",
		content5Item7: "●提交物流运输表格",
		content5Item8: "●预定现场广告",
		content5Item9: "●下载《参展商服务手册》展会资料",
		title6: "主办方发出《报到及布展通知》",
		content6: "现场报到（领取胸卡）、布展，进入展馆的货运车辆需办理《轮候证》",
	},
	callingCard: {
		title1: "中国大陆地区",
		title2: "港澳台及海外地区",
		company1: "上海电缆研究所有限公司",
		company2: "杜塞尔多夫展览（上海）有限公司",
		label1: "电话：",
		label2: "电邮：",
		label3: "手机号：",
		name1: "丁璇 女士",
		name2: "曹莉芳 女士",
		name3: "王诺涵 女士",
		name4: "施伊乐 女士 / 黄娓 女士",
		name5: "卢羽佳 女士",
	},
	registerOthers: {
		searchHolderEn: '按邮箱搜索',
		label3En: '邮箱',
		holder3En: '请输入邮箱',
		columnHeader3En: '邮箱',
		holder13: '请输入邮箱',
		holder16: '邮箱格式无效',
		holder17: '邮箱格式无效',
		searchHolder: "请输入手机号进行搜索",
		searchHolder1: "请输入邮箱进行搜索",
		btn1: "搜索",
		btn2: "为他人预登记",
		btn3: "返回列表",
		btn4: "提交",
		btn5: "查看",
		columnHeader1: "姓名/称谓",
		columnHeader2: "预登记号",
		columnHeader3: "手机号",
		columnHeader4: "部门",
		columnHeader5: "职位",
		columnHeader6: "联系邮箱",
		columnHeader7: "身份证号",
		columnHeader8: "操作",
		columnHeader9: "公司名称",
		label1: "姓名",
		holder1: "请输入姓名",
		label2: "称谓",
		holder2: "请选择称谓",
		label3: "手机号",
		holder3: "请输入手机号",
		label4: "部门",
		holder4: "请输入部门",
		label5: "职位",
		holder5: "请输入职位",
		label6: "联系邮箱",
		holder6: "请输入联系邮箱",
		label7: "身份证号",
		holder7: "请输入身份证号",
		label8: "公司名称",
		holder8: "请输入公司名称"
	},
	visitorEmailInvite: {
		btn1: "邮件邀约",
		btn2: "海报邀约",
		btn3: "新增/批量新增邮件邀请",
		modalTitle: "新增/批量新增邮件邀请（多个请用,隔开）",
		modalHolder: "请输入邮箱地址，多个请用,隔开。",
		modalBtn1: "确认提交",
		modalBtn2: "取消",
		column1: "邮箱地址",
		column2: "姓名",
		column3: "公司名称",
		column4: "职位",
		column5: "邀约状态",
		error1: "邮箱格式不正确",
		error2: "邮箱存在重复数据",
		status1: "已邀约",
		status2: "待邀约",
	},
	boothApply: {
		title1: "请填写以下基本信息，主办方收到后会及时与您联系。",
		title2: "*已提交预订信息的企业，主办方将逐一落实展位，无需重复填写。",
		title3: "本人已经也阅读并同意",
		title4: "“数据保护条例”",
		title5: "并同意此申明所概述的收集及使用本人的个人资料。",
		title6: "请先阅读并同意“数据保护条例”",
		btn1: "提交",
		label1: "称谓",
		holder1: "请选择称谓",
		label2: "姓名",
		holder2: "请输入姓名",
		label3: "公司",
		holder3: "请输入公司名称",
		label4: "部门",
		holder4: "请输入部门",
		label5: "职位",
		holder5: "请选择职位",
		label6: "电话",
		holder6: "请输入电话",
		label7: "手机号码",
		holder7: "请输入手机号码",
		label8: "邮箱",
		holder8: "请输入邮箱",
		label9: "网站",
		holder9: "请输入网站",
		label10: "截止日期",
		label11: "登录密码",
		holder11: "请输入登录密码",
		label12: "确认密码",
		holder12: "请再次输入登录密码",
		holder14: "两次密码输入不一致",
		holder15: "手机号码格式有误",
		holder16: "邮箱格式有误",
		labelCountry: "国家",
		holderCountry: "请输入国家"
	},
	ExList: {
		goToUrlTitle1: "wire China 2024邀请函",
		goToUrlTitle2: "wire China 2024展馆分布图",
		goToUrlTitle3: "wire China 2023展后报告",
		goToUrlTitle4: "wire China 2023电子会刊",
		goToUrlTitle5: "wire China 2023展商名单",
		goToUrlTitle6: "wire China 2022展商名单",
		goToUrlTitle7: "主题路线-高精度测控",
		goToUrlTitle8: "主题路线-高品质线缆及线材",
		goToUrlTitle9: "主题路线-高节能材料",
		goToUrlTitle10: "主题路线-高性能辅助加工",
		goToUrlTitle11: "主题路线-高效率智能装备",
		goToUrlTitle12: "wire China 2020展商名单",
		goToUrlTitle13: "wire China 2018展商名单",
	},
	GroupVisitServiceRequest: {
		PleaseFillInTheFollowingFormProperly: "请您妥善填写以下表格",
		AllRequiredFields: "均必填",
		SendBackByEmail:
			"并邮件回传至：may@secri.com，经主办方审核后会邮件与您确认。",
		FeedbackDeadline: "回传截止：2026年8月28日（周五）",
		WireChinaGroupVisitApplicationForm: "点击立即报名团体参观",
		VIPAudienceTreatment: "5人及以上成团参观：即刻尊享VIP观众礼遇！",
		GroupConditions: "组团条件",
		VIPAudienceBenefits: "观众团参观福利",
		NumberOfPeople: "人数：5人及以上",
		Industry:
			"行业：线材工业、电线电缆工业、钢铁和有色金属工业、汽车工业、宇航工业、电气工业、建筑工业、专业贸易、相关行业服务、相关协会、相关大专院校和研究所、其它。",
		MemberInformation: "*团员信息需经主办单位审核后方可成团",
		GroupVisitors: "团体观众可尊享：",
		VisitorPass: "· 快速领取参观证",
		FreeConferenceBrochure: "· 免费获赠参观指南、电子会刊 ",
		ExhibitionGiftPack: "· 团组观展宣传品",
		GroupPhoto: "· 观众休息室入场券(提供茶饮等)",
		TemporaryDropOffPass: "· 大巴车临时下客证",
	},
	SupplyAndDemand: {
		TheInformationProvidedWillBeUsedTo:
			"*所提供信息将用于展会官方网站渠道、或将用于展会官方微信等推广渠道",
		AddNewDemandInformation: "新增需求信息",
		AddPurchasingRequirements: "新增采购需求",
		SerialNumber: "序号",
		PurchaseDetails: "采购详情",
		Type: "类型",
		Operate: "操作",
		Check: "查看",
		Delete: "删除",
		RequirementDetails: "需求详情",
		BackToList: "返回列表",
		WantToPurchase: "我想采购(可多选)",
		RawMaterials: "原材料",
		Equipment: "机械设备",
		Products: "半制品或制品",
		OtherProductionSolutions: "其他生产解决方案",
		Details: "详情",
		DetailsPoint: "请输入采购需求详情",
		PurchaseQuantity: "采购量",
		PurchaseQuantityPoint: "请输入采购量-材料、机械或产品的所需数量",
		TypePoint: "请选择类型",
		Default: "默认",
		Picture: "图片",
		PicturePoint: "选择图片",
		Submit: "提交",
		ProcurementType: "采购类型",
		PlannedPurchaseVolume: "计划采购量",
		ProcurementTarget: "采购目标",
		PurchaseRequirementsDetails: "采购需求详情",
	},
	MyConsultation: {
		ConsultationList: "咨询列表",
		CheckDetails: "查看详情",
		Supplier: "供应商",
		Product: "产品",
		booth:"展位号",
		ConsultationDetails: "咨询详情",
		CompanyInformation: "公司信息",
		AddressInformation: "地址信息",
		CounterpartyName: "对方姓名",
		CompanyProfileInformation: "公司介绍信息",
		ExhibitInformation: "展品信息",
		ConsultationRecord: "咨询记录",
		PleaseEnterWhatYouWantToReply: "请输入您要回复的内容",
		Submit: "提交",
		SerialNumber: "序号",
		Name: "名称",
		Type: "类型",
		ConsultationContent: "咨询内容",
		ConsultationTime: "咨询时间",
		Controls: "操作",
		PleaseEnterWhatYouWantToConsult: "请输入要咨询的内容",
		NoMore: "不能超过200字",
	},
	Favorites: {
		FavoritesList: "收藏列表",
		SupplierCollection: "供应商收藏", // Supplier Collection
		ExhibitsCollection: "展品收藏", // Exhibits Collection
		SerialNumber: "序号", // Serial number
		SupplierName: "供应商名称", // Supplier name
		Action: "操作",
		UnCollect: "取消收藏",
		NoData: "暂无数据",
		RemoveFavorite: "您确定要取消收藏吗？",
	},
	Conference: {
		Conference: "会议活动",
		ConferenceName: "会议名称",
		RegistrationTime: "报名时间",
		Action: "操作",
		CancelRegistration: "取消报名",
		ConcurrentActivities: "同期活动",
		CableCloudClub: "线缆云会",
		OtherMeetingAndEvents: "其他会议及活动",
		AreYouSureYouWantToCancelYourRegistration: "您确定要取消报名吗？",
		ConferenceRegistration: "会议报名",
	},
	ProductSupplier: {
		Supplier: "供应商",
		SupplierList: "供应商列表",
		Product: "产品",
		booth:"展位号",
		ProductList: "产品列表",
		Consult: "咨询",
		Share: "分享",
		Collect: "收藏",
		Collected: "已收藏",
		PleaseEnterTheContentYouWantToConsult: "请输入您想咨询的内容",
		MaximumInput: "* 最多输入200字",
		ExhibitorsExhibits: "展商展品",
		NewsList: "新闻列表",
		NoMore: "不能超过200字",
		CompanyProfile: "公司介绍",
		Website: "网址",
		Address: "地址",
		RecommendedToYou: "为你推荐",
		PopularCategories: "搜索热点",
		SearchByHall: "馆号搜索",
	},
	AskToBuy: {
		SearchResults: "搜索结果",
		Category: "分类",
		ResultsHaveBeenFoundForYou: "已为您搜索出{total}条结果",
		BuyerPurchasingInformation: "买家采购信息",
		BuyersFrom: "境外采购商",
		UrgentNeeds: "紧急需求",
		ReleaseDate: "发布日期",
		PurchaseProducts: "采购产品",
		PurchaseDetails: "采购详情",
		Quantity: "数量",
		Application: "应用于",
		SuppliersHaveAppliedForMatching: "家供应商已申请匹配",
		ContactBuyer: "联系买家",
		PleaseEnterYourContent: "请输入您的内容",
		OnlyTheAudienceCanConnect: "只有观众才能联系, 请先退出展商登录",
		PleaseVisitorLoginFirst: "请先进行观众登录",
		All: "全部",
		RawMaterials: "原材料",
		Equipment: "机械设备",
		SemiFinishedOrFinishedProducts: "半制品或制品",
		OtherProductionSolutions: "其他生产解决方案",
		classify: {
			all: "全部",
			'': "全部",
			'1': "线缆线材生产与精加工机械",
			'2': "辅助加工",
			'3': "辅助加工材料",
			'4': "材料和特种电线电缆",
			'5': "测控技术",
			'6': "检测工程",
			'7': "相关领域"
		},
		results: "条结果",
		reset: "重置",
		noData: "暂无数据",
		confirm: "确认提交",
		cancel: "取消",
		maxLength: "不能超过200个字符"
	},
	Release: {
		PublishPurchasingRequirements: "发布采购需求", // Publish purchasing requirements
		WantToPurchase: "我想采购(可多选)",
		PleaseSelectThePurchaseType: "请选择采购类型",
		RawMaterials: "原材料",
		Equipment: "机械设备",
		SemiFinishedOrFinishedProducts: "半制品或制品",
		OtherProductionSolutions: "其他生产解决方案",
		PersonalContactInformation: "个人联系信息",
		NickName: "昵称",
		NickNamePlaceholder: "请输入昵称",
		Name: "姓名",
		NamePlaceholder: "请输入姓名",
		CompanyName: "公司名称",
		CompanyNamePlaceholder: "请输入公司名称",
		RegionCountry: "所在地区/国家",
		RegionCountryPlaceholder: "请输入所在国家/地区",
		Phone: "手机号码",
		PhonePlaceholder: "请输入手机号码",
		Email: "电子邮件",
		EmailPlaceholder: "请输入电子邮件",
		Agree1: "本人同意分享本人的联系方式予相关的供应商以进行配对。",
		Agree2:
			"本人确认已阅读及明白，并同意【CPS+在线恭喜对接平台】商贸配对服务一般条款和条件，并确认同意雅式集团的《使用条款》和《隐私政策》所概述的收集及使用本人的个人资料，包括使用及提供本人的个人资料以供直接营销用途。",
		Agree3:
			"我已阅读并同意因雅式集团总部设在中国香港特别行政区，其境外办事处员工和第三方服务可能因业务等需要之时从境外读取或转移个人信息，并不因此减少《隐私政策》下所享有的任何合法权益，并将确保采取相同水平的保护措施。",
	},
	headSearch: {
		PopularSearches: "热门搜索",
		PleaseEnterTheContentYouWantToSearch: "请输入想要搜索的内容",
		PopularSearchProductCategories: "热门搜索产品类别",
		PleaseLoginAsAudience: "请先进行观众登录",
		PleaseLoginAsExhibitor: "请先进行展商登录",
		YouCanNotPerformThisOperation: "您无法进行这项操作",
		NotOpenYet: "暂未开放",
		PleaseLogoutOfAudienceLoginFirst: "请先退出观众登录",
		PleaseLogoutOfExhibitorLoginFirst: "请先退出展商登录",
		CableAndWireProductionAndFinishingMachinery: "线缆线材制造及精加工机械",
		AuxiliaryProcessing: "线缆辅助加工",
		AuxiliaryProcessingMaterials: "线缆（光缆）用原辅材料",
		MaterialsAndSpecialWiresAndCables: "成品线材及电线电缆",
		MeasurementAndControlTechnology: "测控技术",
		TestingEngineering: "检测工程",
		RelatedAreas: "其他相关领域",
	},
	ExCenter: {
		FrontPage: "首页",
		BasicInformation: "基本信息",
		CompanyInformation: "公司信息",
		ExhibitInformation: "展品信息",
		ExhibitorPromotionApplication: "媒体服务",
		BillingInformation: "开票信息",
		ChangePassword: "修改密码",
		ExhibitorServices: "参展商服务",
		ExhibitorServiceManual: "参展商服务手册",
		ExhibitorInvite: "展商邀请",
		ExhibitorInvitation: "展商邀请",
		ConferenceInformation: "会刊信息",
		OnlineInvitation: "参展邀请函",
		ExhibitorBadge: "证件管理",
		AdvertisingServices: "广告服务",
		Down:"资源下载",
		BusinessSupplyAndDemandDockingManagement: "商贸供需对接管理",
		MyMatchmakingApplication: "配对申请",
		Consult: "咨询",
		SupplierAndProductCollection: "供应商及产品收藏",
		MyPurchasingNeeds: "采购需求",
		CompanyName: "公司名称",
		BoothNumber: "展位号",
		BoothType: "展位类型",
		BoothArea: "展位面积",
		SquareMeter: "平方米",
		ContentToBeFilledIn: "待填写内容",
		Deadline: "截止时间",
		FinishedCondition: "完成状态",
		NotCompleted: "未完成（去填写）",
		ViewTheExhibitorServiceManualOverview: "查看参展商服务手册总览",
	},
	Company: {
		CompanyInformation: "公司信息",
		CompanyOverview: "公司预览",
		CompanyName: "公司名称",
		CompanyNameCN: "公司中文名称",
		CompanyNameEN: "公司英文名称",
		BoothNumber: "展位号",
		BoothType: "展位类型",
		BoothRange: "展位面积",
		ExhibitorClassification: "展商分类",
		CompanyAndProductIntroduction: "公司/产品中文简介",
		CompanyAndProductIntroductionEN: "公司/产品英文简介",
		ProductBrand: "主营产品",
		ApplicationArea: "应用领域",
		CompanyPhone: "公司电话",
		CompanyFax: "公司传真",
		CompanyWebsite: "公司网址",
		CompanyAddress: "公司地址",
		RawSpaceBooth: "光地展位",
		StandardBooth: "标准展位",
		DigitalIntelligenceEmpowersInnovativeEquipment: "数智赋能创新装备",
		AuxiliaryProcessingSupporting: "辅助加工配套",
		GreenAndLowCarbonSolutions: "绿色低碳解决方案",
		QualityCablesAndWires: "品质线缆线材",
		PrecisionMeasurementAndControlTechnology: "精准测测控技术",
		CompanyAddressLengthCannotBeLessThanXCharacters:
			"公司地址长度不能少于10个字符",
		companyType1: "线缆线材生产与精加工机械",
		companyType2: "线缆辅助加工",
		companyType3: "线缆(光缆)用原辅材料",
		companyType4: "成品线材及电线电缆",
		companyType5: "测控技术",
		companyType6: "检测工程",
		companyType7: "相关领域",
		nationalSingleChampion: "国家级制造业单项冠军企业",
		nationalGiant: "国家级专精特新\"小巨人\"企业",
		specializedSme: "专精特新中小企业",
		innovativeSme: "创新型中小企业",
	},
	Exhibit: {
		AddExhibitInformation: "新增展品信息",
		EditExhibitInformation: "编辑展品信息",
		ExhibitDetails: "展品详情",
		ExhibitNameCn: "展品名称（中文）",
		ExhibitNameEn: "展品名称（英文）",
		ExhibitCategory: "展品类别",
		ExhibitPictures: "展品图片",
		ExhibitsCategories: "展品分类",
		CategoryTags: "应用领域",
		CustomTags: "应用领域",
		VideoUpload: "视频上传(选填)",
		ExhibitIntroductionCn: "展品简介（中文）",
		ExhibitIntroductionEn: "展品简介（英文）",
		AuditStatus: "审核状态",
		WriteLyricsForMe: "为我填词",
		instructionManual:
			"备注说明：请选择您的展品类别，如以上类别不能覆盖您的展品，请另行添加您的专属词条。",
		ItIsRecommendedToAddWatermark: "上传展品照片建议添加水印",
		OnlyVideosInMp4FormatCanBeUploaded: "只能上传mp4格式的视频",
	},
	Apply: {
		AddPromotionalInformation: "新增宣传信息",
		AddExhibitorsPromotionalInformation: "新增展商宣传申请",
		EditExhibitorsPromotionalInformation: "编辑展商宣传申请",
		ExhibitorPromotionApplicationDetails: "展商宣传申请详情",
		ManuscriptWordCount:
			"*稿件字数在800-1200字为佳。建议提供公司简介/产品介绍/案例分享/技术介绍等文稿内容。\n图片4-6张，单张图片小于2M，上传产品图片建议添加水印。",
		TitleCn: "标题（中文）",
		TitleEn: "标题（英文）",
		CoverImage: "封面图片",
		ContentCn: "内容（中文）",
		ContentEn: "内容（英文）",
		File: "文件",
	},
	Service: {
		ExhibitorServices: "展览指南",
		BuildingServices: "所有展商提交",
		PublicityServices: "标准展位展商",
		ShipmentService: "光地及标改特展商",
		OtherService: "其他可选服务",
		TransportService: "运输服务",
		SubmissionDeadline: "递交期限",
		TableType: "表格类型",
		FeedbackContact: "反馈联系",
		Title: "标题",
		Require: "是否必填",
	},
	OnlineInvite: {
		MobileInvitation: "手机端邀约",
		WeChatInvitationLetterGenerationSteps: "微信邀请函生成步骤",
		FillInCompanyInformation: "填写“公司信息”",
		Completed: "已填写",
		Selected: "已选择",
		UploadExhibitInformation: "选择模版",
		PleaseSelectOne: "请选择其中一个邀请函模版",
		GenerateCustomized: "生成定制化“微信邀请函”",
		ScanTheQRCodeBelow: "扫描下方二维码或复制链接",
		YouCanBrowseYourInvitationPageOnline:
			"请使用微信扫描上方二维码 或 复制以下链接至微信。即可在线浏览您的邀请函页面，记得转发分享哦~",
		KindTips:
			"温馨提示：为了更好的对参展企业进行宣传，主办单位将以参展企业名义对您的优质客户进行特别邀请。如有需要邀请的优质客户，请填写下表。受邀请的客户将获得以下权益：",
		KindTips1: "1、现场快速换证；",
		KindTips2: "2、快速获取邀请单位的参展信息；",
		KindTips3: "3、免费展会会刊一本；",
		KindTips4: "4、精美观众礼品一份。",
		AddBatchAddEmailInvitations: "新增/批量新增邮件邀请",
		Invited: "已邀约",
		WaitingInvitation: "待邀约",
		PosterStylePreview: "海报样式预览",
		DownloadPoster: "下载海报",
		Name: "姓名",
		CompanyName: "公司名称",
		Position: "职位",
		InvitationStatus: "邀约状态",
	},
	ExhibitorCard: {
		KindTips: "温馨提示",
		KindTips1: "1.参展商证仅限参展企业工作人员使用，请勿转借他人。",
		KindTips2:
			"2.请于布展到期时间，至现场报到处领取参展商证。（详细说明，请见《报到及布展通知》）。",
		TheIssuanceStandardsAreAsFollows: "参展商证件免费发放标准如下：",
		IssuanceStandards1: "9平米标摊 3张参展证",
		IssuanceStandards2: "10平方米-18平方米 5张参展证",
		IssuanceStandards3: "19平方米-36平方米 8张参展证",
		IssuanceStandards4: "37平方米-54平方米 12张参展证",
		IssuanceStandards5: "55平方米-72平方米 16张参展证",
		IssuanceStandards6: "73平方米-107平方米 20张参展证",
		IssuanceStandards7: "108平方米以上 25张参展证",
		OnlineRegistrationForExhibitorsHasClosed:
			"展商证在线提交平台已关闭，如有变更或新增请于现场报到时告知工作人员。",
		AddExhibitorBadge: "新增展商证",
		EditExhibitorBadge: "编辑展商证",
		ExhibitorBadgeDetails: "展商证详情",
		Name: "姓名",
		CardType: "证件类型",
		IdCardNo: "证件号",
		CardImage: "证件照",
		IDCardPassport: "身份证/护照",
		Identity: "身份证",
		Passport: "护照",
		Other: "其他",
		CompanyName: "公司名称",
		Position: "职位",
		PhoneNumber: "手机号",
		InvalidBoothArea: "无效的展位面积",
		CannotAddMoreExhibitorBadges: "不能添加更多的展商证",
		OnlyDataThatFailedTheReviewCanBeEdited: "只能编辑审核失败的数据",
	},
	ExhibitorServiceManual: {
		PleaseEnter: "请输入",
		ExhibitorBadgeApplication: "参展商证件申请",
	},
	AdvertisingService: {
		AddAdvertisingServices: "新增广告服务",
		EditAdvertisingServices: "编辑广告服务",
		AdvertisingServiceDetails: "广告服务详情",
	},
	Pairing: {
		DemandInformationThatMayInterestYou: "您可能感兴趣的需求信息",
		BuyersFrom: "来自中国的买家",
		MyPairingList: "我的配对清单",
		Paired: "已配对",
		AwaitingReview: "待审核",
		SuccessfulAudit: "审核成功",
		Source: "来源",
		ProcurementRequirements: "采购需求",
		ReleaseDate: "发布日期",
		SerialNumber: "序号",
		MyMatchmakingApplication: "我的配对申请",
		ApplicationTime: "申请时间",
	},
	Consult: {
		ConsultMy: "咨询我的",
		MyConsultation: "我的咨询",
	},
	AuditStatus: {
		Status: "状态",
		All: "全部",
		UnderReview: "审核中",
		AuditPassed: "审核通过",
		AuditFailure: "审核失败",
		Unanswered: "未回复",
		Replied: "已回复",
		Closed: "已关闭",
		AuditFailureSubmit:"审核失败，重新提交"
	},
	custom: {
		offdate:"天过期",
		novalidCoupons: "暂无有效优惠券",
		notFilled: "请填写内容",
		ScanQRCode: "扫码预定",
		SignUpTips: "报名成功",
		SignUp: "点击报名入口",
		ExhibitRecommendation: "展品推荐",
		ExhibitorRecommendation: "展商推荐",
		PopularVideosAndLiveStreams: "热门视频&直播",
		FeaturedExhibits: "特色商品展示",
		HallSearch: "展馆搜索",
		PleaseEnterTitle: "请输入标题",
		PleaseEnterIntroduction: "请输入简介",
		PleaseUploadCoverImage: "请上传封面图片",
		PleaseEnterTheContent: "请输入内容",
		CannotEditDataUnderReview: "不能编辑审核中的数据",
		ApprovedDataCannotBeEdited: "不能编辑审核通过的数据",
		Title: "标题",
		CoverImage: "封面图",
		BriefIntroduction: "简介",
		Content: "内容",
		ReleaseTime: "发布时间",
		sm: "请下载所需文件，填写完成后邮件至相应供应商邮箱，如有问题可随时联系roger@secri.com",
		hk: "会刊信息基本信息与合同一致，请填写简介，如有问题可与联系roger@secri.com",
		Action: "操作",
		ConferenceJournalTips: "所填信息将用于展会官方网站、微信推广渠道。专精特新现场信息展现收集已停止，线上可继续提交信息",
		ConferenceJournalSuggestAddingWatermark: "上传产品照片建议添加水印",
		State: "状态",
		All: "全部",
		UnderReview: "审核中",
		ExaminationPassed: "审核通过",
		AuditFailure: "审核失败",
		AddedConferenceInformation: "新增会刊信息",
		EditingConferenceInformation: "编辑会刊信息",
		ViewConferenceInformation: "查看会刊信息",
		EditSuccess: "编辑成功",
		Submit: "提交",
		imageSizePoint: "建议尺寸为200px*100px支持格式jpg、png",
		TheCoverImageIsForOnlineAdvertisingPurposesOnly:
			"点击上传封面图，封面图仅用于在线宣传。建议尺寸为200px*100px支持格式jpg、png",
		imageSizeAlert: "只能上传jpg或png格式的图片",
		dataLoadFailed: "数据加载失败，请稍后重试",
		singleUploadAlert: "只能上传1个文件",
		BackToList: "返回列表",
		Upload: "上传",
		Reset: "重置",
		Edit: "编辑",
		Check: "查看",
		Delete: "删除",
		DeleteTitle: "您确定删除吗？",
		Yes: "确定",
		No: "取消",
		SuccessfullyDeleted: "删除成功",
		EnterTheContentYouNeedToSearch: "请输入你需要搜索的内容",
		Supplier: "供应商",
		Product: "产品",
		SeeMore: "查看更多",
		BuyerPurchasingNeeds: "买家采购需求",
		PopularVideosAndLiveBroadcasts: "热门视频&直播",
		PlaceOfUse: "使用地点",

		DateOfUse: "使用时间",
		TheInformationProvidedWillBeUsedTo:
			"*所提供信息将用于展会官方网站渠道、或将用于展会官方微信等推广渠道",
		AddNewDemandInformation: "新增需求信息",
		PleaseReferToTheOnSiteAnnouncement:
			"*以上议程如有更改，恕不另行通知，请以现场公告为准。",
		Time: "时间",
		Topic: "活动",
		Speaker: "备注",
		ThemeName: "主题名称",
		Venue: "地点",
		LiveBroadcastPreviewPreviousEpisodes: "直播预告 | 往期回顾",
		GetTheVideoViewingLink: "添加下方联系人微信，获取观看链接",
		CableCloudConsulting: "线缆云会咨询",
		CableCloudPreviousEpisodes1: "2023第01期-绿色低碳线缆材料的创新趋势研讨",
		CableCloudPreviousEpisodes2: "2023第02期-线缆研发中的模拟仿真技术趋势研讨",
		CableCloudPreviousEpisodes3: "2023第03期-智能制造与线缆设备的创新趋势研讨",
		CableCloudPreviousEpisodes4:
			"2023第04期-电线电缆计算机辅助设计软件的应用及趋势研讨",
		CableCloudPrevContactUsCompany: "上海电缆研究所有限公司",
		CableCloudPrevContactUsTitle: "信息会展中心",
		CableCloudPrevContactUsName: "刘建伟 先生",
		CableCloudPrevContactUsPhone: "电话：18817395216",
		CableCloudPrevContactUsEmail: "charles@secri.com",
		ExhibitionNotice: "境外展会",
		RecentActivities: "展会预告",
		Location: "地点",
		ExhibitionVisitConsultation: "参展/参观咨询",
		ExhibitionLocation1: "印度 · 孟买",
		ExhibitionLocation2: "墨西哥 · 蒙特雷",
		ExhibitionLocation3: "土耳其 · 伊斯坦布尔",
		ExhibitionLocation4: "埃及 · 开罗",
		ExhibitionLocation5: "德国 · 杜塞尔多夫",
		SharedURLCopied: "已复制分享地址",
		YouHaveAlreadyCollected: "您已经收藏过了",
		ConfirmSubmission: "确认提交",
		Cancel: "取消",
		ThereIsAProblemAccessingTheAddress: "访问地址出现问题",
		NoMore: "不能超过200字",
		NoData: "暂无数据",
		IHaveAlsoReadAndAgreed: "本人已经也阅读并同意",
		PrivacyPolicyStatement: "隐私政策声明",
		AgreeToTheCollectionAndUseOfPersonalData:
			"并同意此申明所概述的收集及使用本人的个人资料。",
		PleaseReadAndAgreeToThePrivacyPolicyStatementFirst:
			"请先阅读并同意“隐私政策声明”",
		PleaseEnter: "请输入{value}",
		PleaseChoose: "请选择{value}",
		MaxLength: "{value}不能超过{length}个字符",
		PleaseUpload: "请上传{value}",
		UploadFiles: "上传文件",
		RecommendedSize: "建议大小",
		TheFileSizeCannotExceed: "文件大小不能超过",
		TaxID: "税号",
		Save: "保存",
		Email: "邮箱",
		Completed: "已完成",
		Undone: "未完成",
		FillInOnline: "在线填写",
		Uploaded: "已上传",
		Download: "下载",
		NoFileWasFoundToDownload: "没有获取到要下载的文件",
		CheckDetails: "查看详情",
		PleaseLogin: "请先登录",
		Phone: "手机号码",
		PhonePlaceholder: "请输入手机号码",
		PhoneCodePlaceholder: "请输入正确手机号，以便获取验证码",
		VisitorCenterAccount: "该手机号码将作为您登录观众中心的账号",
		CgtCenterAccount: "该手机号码将作为您登录观众团系统的账号",
		VerificationCode: "验证码",
		VerificationCodePlaceholder: "请输入验证码",
		ResendVerificationCode: "{value}s后重发",
		GetVerificationCode: "获取验证码",
		CapturingDownloadingImages: "捕获和下载图片时出错:",
		FillOutTheAudienceQuestionnaire: "弹窗提示填写观众问卷",
		SMSVerificationCodeSentSuccessfully: "短信验证码发送成功",
		EmailVerificationCodeSentSuccessfully: "邮箱验证码发送成功",
		isRequire: "必填",
		notRequire: "非必填",
	},
	subscribeDialog: {
		title: "订阅展讯",
		label1: "我是",
		holder1: "请选择身份",
		label2: "公司",
		holder2: "请输入公司名称",
		label3: "姓名",
		holder3: "请输入姓名",
		label4: "邮箱",
		holder4: "请输入邮箱",
		btn1: "确认提交",
		btn2: "取消",
	},
	changePsw: {
		btn: "确认",
		label1: "旧密码",
		holder1: "请输入旧密码",
		label2: "新密码",
		holder2: "请输入新密码",
		label3: "确认新密码",
		holder3: "请再次输入新密码",
		holder4: "两次密码输入的不一致",
	},

	journal: {
		companyCn: "公司中文名",
		companyCnHolder: "请输入公司中文名",
		companyEn: "公司英文名",
		companyEnHolder: "请输入公司英文名",
		companyAddress: "公司地址",
		companyAddressHolder: "请输入公司地址",
		phone: "公司电话",
		phoneHolder: "请输入公司电话",
		fax: "公司传真",
		faxHolder: "请输入公司传真",
		webSite: "公司网址",
		webSiteHolder: "请输入公司网址",
		contentCnMaxLength: "中文介绍不能超过105个字符",
		contentEnMaxLength: "英文介绍不能超过220个字符",
		contentCn: "中文介绍",
		contentCnHolder:
			"请输入中文介绍（限定105个字符(1个汉字或1个标点符号均计为1个字符)）",
		contentEn: "英文介绍",
		contentEnHolder:
			"请输入英文介绍（限定220个字符(1个字母或1个标点符号均计为一个字符）",
		classify: "产品分类代码",
		classifyHolder: "请选择产品分类代码",
		submit: "提交",
	},
	template1: "模版一",
	template2: "模版二",
	template3: "模版三",
	adType: "广告类型",
	adType1: "现场广告",
	adType2: "印刷广告",
	adType3: "网络宣传广告",
	add: "新增",
	name: "名称",
	description: "描述",
	saleOut: "是否售磬",
	Y: "是",
	N: "否",
	price: "价格",
	unit: "单位",
	buyAmount: "购买数量",
	attachment: "附件",
	createTime: "创建时间",
	auditState: "审核状态",
	auditState1: "审核中",
	auditState2: "已通过",
	auditState3: "已驳回",
	copySuccess: "复制成功",
	toRegister: "请先注册成为观众",
	tokenFailed: "用户已失效，请重新登录",
	publishType: {
		urgentNeed: "紧急需求",
		oneoffDemand: "一次性需求",
		periodiclongtermNeed: "定期/长期需求",
	},
	searchInputEmpty: "请输入要搜索的内容",
	searchNodata: "无搜索结果",
	search: {
		includesStarter: "包含“",
		includesEnder: "”的关键字搜索结果",
		typeCompany: "展商",
		typeEntry: "展品",
		typePurchase: "求购信息",
		typeDynamic: "展会动态",
		typeExhibitor: "参展商名单",
		typeFile: "展会资料",
		detail: "查看详情",
	},
	groupRegister: {

		backupPlaceholder: "至多200个字符",
		backup: "备注",
		contactPerson: "联系人",
		contactPhone: "联系人电话",
		contactEmail: "联系人邮箱",
		teamApplyTitle: '参观团申请',
		teamApplyTips: '温馨提示',
		teamApplyDesc: '您正在申请创建一个新的参观团。创建成功后，您将作为该参观团的联系人，可以管理团队成员和申请信息。',
		currentUserInfo: '当前用户信息',
		groupNameLength: '团体名称长度在2-50个字符之间',
		expectedCountRange: '预计人数应在1-1000之间',
		backupMaxLength: '备注不能超过500个字符',
		submitApply: '提交申请',
		cancel: '取消',
		groupNameTips: '请填写参观团的正式名称，建议使用单位全称',
		expectedCountTips: '请根据实际情况填写，后续可以修改',
		backupTips: '如有特殊需求或说明，请在此填写',
		otherInfoTitle: '其他信息说明',
		otherInfoDesc: '横幅、大巴等附加信息可在参观团创建后，在参观团管理页面中进行补充和完善。',
		loginRequired: '请先登录',
		loadUserInfoFailed: '加载用户信息失败',
		applySuccess: '参观团申请提交成功',
		applyFailed: '申请提交失败，请稍后重试',
		title: "参观团注册",
		step: "参观团注册",
		groupInfo: "参观团信息",
		contactInfo: "联系人信息",
		contactNote: "联系人将作为参观团管理员",
		contactStep:"信息验证",
		successStep:"完成注册",
		groupInfoStep:"填写信息",
		questionStep:"问卷调查",
		// 表单字段
		groupName: "团体名称",
		groupNamePlaceholder: "请输入团体名称",
		nature: "团体性质",
		naturePlaceholder: "请选择团体性质",
		natureEnterprise: "企业",
		natureGovernment: "政府",
		natureAssociation: "协会",
		natureSchool: "学校",
		natureOther: "其他",
		expectedCount: "预计人数",
		expectedCountPlaceholder: "请输入预计参观人数",
		expectedCountMin: "预计人数至少为1人",
		contactPosition: "联系人职务",
		contactPositionPlaceholder: "请输入联系人职务",

		// 按钮
		submitBtn: "立即注册",
		registering: "注册中...",

		// 已有账号提示
		haveAccount: "已有账号？",
		loginNow: "立即登录",

		// 消息提示
		groupCreateFailed: "创建参观团失败",
		contactCreateFailed: "创建联系人失败",
		loginFailed: "自动登录失败",
		registerSuccess: "参观团注册成功！正在跳转到团组中心...",
		registerFailed: "注册失败，请稍后重试",
		validateFailed: "表单验证失败，请检查填写内容",
		groupNature:"参观团性质",
		goToGroupCenter:"团体中心",
		groupCode:"注册码",
		successTitle:"注册成功",
	},
	common: {
		"ok": "确定",
		"cancel": "取消",
		"confirm": "确认"
	},
	groupCenter: {
		ok:"确认",
		cancel:"取消",
		nameLength:"姓名不能超过50个字符",
		"batchDeleteErrorLog": "批量删除失败:",
		"deleteFailed": "删除失败",
		"deleteErrorLog": "删除团员失败:",
		"email": "邮箱",
		"nameLengthError": "姓名不能超过50个字符",
		"companyLengthError": "单位名称不能超过100个字符",
		"loadMemberFailed": "加载团员列表失败",
		"confirmDelete": "确认删除",
		"batchDeleteConfirm": "确定要删除选中的 {count} 个团员吗？",
		"deleteConfirm": "确定要删除团员 {name} 吗？",
		"deleteSuccess": "删除成功",
		"selectMember": "请选择要删除的团员",
		"operationFailed": "操作失败",
		editSuccess: "编辑成功",

		memberid:"身份证号",
		idNumberRequired:"请输入身份证号码",
		error:"错误",
		genxinerror:"信息更新失败",
		genxinsuccess:"信息更新成功",
		ren:"位",
		editGroupModaltitle:"编辑团体信息",
		idNumberFormat:"身份证号码格式错误",
		editMember:"编辑团员信息",
		importSuccess:"导入成功",
		menuLabel7: "团体权益",
		menuLabel7Item1: "管理团体权益",
		cardContent9: "团体权益",
		hoverContent9: "申请和管理团体权益",
		phoneRequired:"请输入团员联系方式",
		companyRequired:"请输入团员身份证",
		nameRequired:"请输入团员名称",
		delete:"删除",
		edit:"编辑",
		addSuccess:"添加成功",
		action:"操作",
		phoneFormat:"联系方式格式错误",
		downloadTemplate:"下载模板",
		importBtn:"导入",
		noFileSelected:"未选择文件",
		selectFile:"请选择文件",
		addMemberBtn:"添加团员",
		back:"返回团体中心首页",
		memberManage:"团员管理",
		batchDelete:"批量删除",
		batchImportDesc:"仅支持Excel文件上传，请下载模版后按照模版格式填写，观众团id不要修改",
		batchImport:"批量导入团员",
		searchPlaceholder:"请输入团员关键字",
		phonePlaceholder:"请输入团员联系方式",
		companyPlaceholder:"请输入团员公司",
		namePlaceholder:"请输入团员名称",
		idNumber:"身份证",
		idNumberPlaceholder:"请输入团员身份证号",
		mailPlaceholder:"请输入团员邮箱",
		mailerror:"邮箱格式错误",
		memberCompany:"公司",
		memberPhone:"手机号",
		memberName:"姓名",
		memberMail:"邮箱",
		addMember:"添加团员",
		createTime:"创建时间",
		groupName:"团体名称",
		editGroup:"编辑团体信息",
		refresh:"刷新团体信息",
		noGroupTitle: '您还没有参观团',
		noGroupDesc: '您还没有创建或加入任何参观团，请先创建或申请加入参观团',
		createGroupBtn: '申请参观团',
		noGroupWarn: '请先创建或加入参观团才能使用此功能',
		title: "团体中心",
		menuLabel1: "首页",
		menuLabel2: "参观登记",
		menuLabel2Item1: "电子团体参观证",
		menuLabel2Item2: "团体参观权益",
		menuLabel2Item4: "团体问卷",
		menuLabel3: "团队服务",
		menuLabel3Item1: "添加团员",
		menuLabel3Item2: "团员管理",
		menuLabel3Item3: "邀请好友注册",
		menuLabel4: "采购服务",
		menuLabel4Item1: "我发布的采购需求",
		menuLabel4Item2: "我的咨询",
		menuLabel4Item3: "供应商及产品收藏",
		menuLabel5: "会议活动",
		menuLabel6: "联系我们",
		menuLabel7Item2: "团员管理",
		label7:"观众团预登记入口将于北京时间2026年9月20日12:00准时关闭，敬请留意。",
		footerTitle: "退出登录",
		label1: "尊敬的",
		label2: "欢迎您登录观众团中心",
		label3: "您可以在此处管理您的参观团及相关服务",
		groupInfo: "团体信息",
		groupCode: "团体编码",
		memberCount: "成员数量",
		groupInstructions: "团体参观说明",
		instruction1: "团体参观需统一入场，请提前15分钟在指定地点集合",
		instruction2: "团体负责人需携带有效证件及团体参观证",
		instruction3: "每位团员需携带个人有效证件",
		instruction4: "团体参观注意事项",
		instruction5: "请遵守展会现场秩序，保持团体队列整齐",
		instruction6: "如有特殊需求，请提前与展会工作人员联系",
		contactInfo: "联系方式",
		successMessage3: "您的团体参观证已生成，请妥善保管",
		douhao: "，",
		maohao: "：",
		downloadCard: "下载参观证",
		manageMembers: "管理团员",
		cardContent1: "电子团体参观证",
		cardContent2: "团体参观权益",
		cardContent3: "发布采购需求",
		cardContent4: "供应商及产品收藏",
		cardContent5: "团体参观服务申请",
		cardContent6: "会议活动",
		cardContent7: "团员管理",
		hoverContent1: "查看并下载您的团体电子参观证",
		hoverContent2: "查看团体参观享有的各项权益",
		hoverContent3: "发布您的采购需求，寻找合适供应商",
		hoverContent4: "收藏感兴趣的供应商及产品",
		hoverContent5: "申请团体参观相关服务",
		hoverContent6: "查看并报名相关会议活动",
		hoverContent7: "管理您的团员信息",
		groupNature:"参观团性质",
		modal: {
			title: "温馨提示",
			content: "您还未填写团体问卷，是否现在填写？",
			btn: "去填写"
		}
	},
	"groupBenefits": {

		"duplicateSubmission": "请不要重复提交申请，系统正在处理中",
		conditionNotMet: "未满足申请条件",
		"back": "返回",
		"benefitRules": "团体权益申请规则",
		"rule1": "5人及以上团员，可申请横幅",
		"rule2": "30人及以上团员，可申请餐券",
		"rule3": "30人及以上团员，且接送地点离展馆300公里以内，可申请免费大巴接送",
		"currentMembers": "当前团员数量",
		"lastUpdate": "最后更新",
		"applyFormTitle": "团体权益申请",
		"bannerLabel": "横幅申请",
		"available": "可申请",
		"unavailable": "不可申请",
		"conditionallyAvailable": "可申请",
		"bannerContent": "横幅内容",
		"bannerContentRequired": "请输入横幅内容",
		"bannerContentMaxLength": "横幅内容最多50字",
		"bannerContentPlaceholder": "请输入横幅内容（最多50字）",
		"bannerRequirement": "需{count}人及以上团员可申请",
		"ticketLabel": "餐券申请",
		"ticketCount": "餐券数量",
		"ticketCountPlaceholder": "请输入餐券数量",
		"ticketCountMin": "餐券数量不能为负数",
		"ticketCountMax": "餐券数量不能超过团员数量（最多{count}张）",
		"ticketRequirement": "需{count}人及以上团员可申请",
		"busLabel": "大巴接送申请",
		"distanceKm": "接送公里数",
		"distancePlaceholder": "请输入距离展馆的公里数",
		"distanceMin": "公里数不能为负数",
		"distanceWithinLimit": "距离在300公里以内，符合申请条件",
		"distanceExceedLimit": "距离超过300公里，不符合申请条件",
		"busCount": "大巴数量",
		"busCountPlaceholder": "请输入大巴数量",
		"busCountRequired": "请输入大巴数量",
		"busCountMin": "大巴数量至少1辆",
		"busCountMax": "大巴数量最多10辆",
		"busRequirement": "需{count}人及以上团员且距离展馆300公里内可申请",
		"pickupLocation": "接地点",
		"pickupLocationPlaceholder": "请输入接送起始地点（如：酒店门口）",
		"pickupLocationMaxLength": "接地点最多100字",
		"dropoffLocation": "送达地点",
		"dropoffLocationPlaceholder": "请输入送达地点（如：展馆正门）",
		"dropoffLocationMaxLength": "送达地点最多100字",
		"locationInfo": "接送信息",
		"remark": "备注",
		"remarkPlaceholder": "请输入其他说明或要求",
		"currentBenefits": "当前已申请的权益",
		"banner": "横幅",
		"ticket": "餐券",
		"bus": "大巴",
		"noBenefits": "尚未申请任何权益",
		"cancel": "取消",
		"submit": "提交申请",
		"selectAtLeastOne": "请至少填写一项权益信息",
		"applySuccess": "申请提交成功",
		"bannerApplied": "横幅申请已提交",
		"ticketApplied": "餐券申请已提交（{count}张）",
		"busApplied": "大巴接送申请已提交（{count}辆，距离{distance}公里）",
		"applyFailed": "申请提交失败，请稍后重试",
		"loadDataFailed": "加载数据失败",
		"unitPerson": "张",
		"unitKm": "公里",
		"unitVehicle": "辆",
		"busDistanceWarning": "距离展馆超过300公里不符合免费大巴申请条件",
		"ticketAppliedDesc": "已申请餐券",
		"busAppliedDesc": "已申请大巴",
		"distance": "距离",
		"contactStaff": "工作人员将尽快与您确认申请详情"
	},
};
